import { render, staticRenderFns } from "./growersalesstatement2.vue?vue&type=template&id=28d60c6c"
import script from "./growersalesstatement2.vue?vue&type=script&lang=js"
export * from "./growersalesstatement2.vue?vue&type=script&lang=js"
import style0 from "./growersalesstatement2.vue?vue&type=style&index=0&id=28d60c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports